import * as types from './mutation_types'

export default {
  [types.COMMENTS] (state, value) {
    state.comments = value
  },
  [types.NOTIFICATIONS] (state, value) {
    state.notifications = value
  },
  [types.SET_ENTITY_ID] (state, value) {
    state.entityId = value
    state.isLoadedEntityId = true
  },
  [types.IS_LOADED_COMMENTS] (state, value) {
    state.isLoadedComments = value
  },
  [types.NOTIFICATIONS_COUNT] (state, value) {
    state.notificationsCount = value
  },
  [types.IS_FROM_NOTIF] (state, value) {
    state.isFromNotif = value
  },
  [types.NOTIF_LINK] (state, value) {
    state.notifLink = value
  },
  [types.IS_LOADED_ENTITY_ID] (state, value) {
    state.isLoadedEntityId = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/comments/mutations.js